export function getDisplayName<T>(
    component: React.FC<T>,
    defaut = 'Component',
) {
    const displayName = component?.displayName || component?.name || defaut;

    return displayName;
}
